var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:['ee-pb', _vm.clase]},[_c('div',{staticClass:"ee-pb-h"},[_c('p',{staticClass:"ee-pb-t"},[_vm._v(_vm._s(_vm.titulo))]),_vm._t("extra")],2),(_vm.ayuda)?_c('p',{staticClass:"ee-pb-c"},[_vm._v(_vm._s(_vm.ayuda))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }